import '../../modules/mode-components';

import * as angular from 'angular';
import { highlightElement } from 'prismjs';

import { StringHelpers } from '@mode/shared/util-js';
import { HIGHLIGHT_LIMIT } from '../../common/constants';

const LiveCodeHighlightDirective = function ($timeout) {
  return {
    scope: {
      lang: '@?',
      lineNumbers: '@?',
      start: '@?',
      code: '<',
    },
    template: '<pre><code class="mode-prism"></code></pre>',
    link: function (scope, elem, attrs) {
      const code = elem.find('.mode-prism');
      elem.addClass('mode-code');
      if (scope.lang) {
        code.addClass('language-' + scope.lang);
      }
      if (scope.lineNumbers) {
        elem.find('pre').addClass('line-numbers');
      }

      if (scope.start) {
        elem.find('pre').attr('data-start', '' + scope.start);
      }

      scope.$watch('code', () => {
        $timeout(
          () => {
            code[0].innerHTML = StringHelpers.escapeHTML(scope.code);
            if (code[0].innerHTML.length < HIGHLIGHT_LIMIT) {
              highlightElement(code[0], false);
            }
          },
          0,
          false
        );
      });
    },
  };
};

LiveCodeHighlightDirective.$inject = ['$timeout'];

angular.module('mode.components').directive('modeLiveCode', LiveCodeHighlightDirective);
